import { Injectable } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { LogglyService } from 'ngx-loggly-logger';
import { ErrorModalComponent } from '../components/error-modal/error-modal.component';
import { CustomerService } from './customer.service';
import { SnackbarService } from './snackbar.service';
import { UserService } from './user.service';

@Injectable()
export class ErrorService {
	constructor(private _logglyService: LogglyService,
				private _dialog: MatDialog,
				private _userService: UserService,
				private _customerService: CustomerService,
				private _snackbarService: SnackbarService) {
	}

	error(error, logText?: any, alertType?: string) {
		if (logText) {
			const user = this._userService.getUser();
			const log = {
				user: {username: user ? user.username : null, clientId: user ? user.cxtId : null, selectedCustomer: this._customerService.getSelectedCustomer()},
				text: logText,
				error: error
			};
			this._logglyService.push({log});
		}

		if (alertType) {
			let title: string, message: string;

			if (error && error.error) {
				if (typeof error.error === 'string') {
					try {
						error = JSON.parse(error.error);
					} catch (e) {
						error = error.error;
					}
				} else {
					error = error.error;
				}
			}

			if (error && error.generalMsg) {
				title = error.generalMsg;
				message = error.detailedMsg || 'An unexpected error occurred. Please try again.';
			} else {
				title = 'Error';
				message = (error && error.message) ? error.message : 'An unexpected error occurred. Please try again.';
			}

			if (alertType === 'modal') {
				const dialogConfig = new MatDialogConfig();
				dialogConfig.autoFocus = false;
				dialogConfig.width = '600px';
				dialogConfig.maxWidth = '100vh';
				dialogConfig.data = {error: title, errorDetail: message};
				return this._dialog.open(ErrorModalComponent, dialogConfig);
			} else if (alertType === 'toast') {
				this._snackbarService.openSnackBar(message, 'Close', null);
			}
		}
	}
}
